import { CategoryPage } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import { onlineClassesUrl } from "@outschool/routes";
import { useMemo } from "react";

export const useGetSeoBreadcrumbTrailScript = (category?: CategoryPage) => {
  const { t } = useTranslation(
    "client\\components\\categories\\CategoryBreadcrumbs"
  );

  return useMemo(() => {
    if (!category) {
      return [];
    }

    const jsonTrail = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: t("All classes"),
          item: onlineClassesUrl()
        }
      ]
    };

    const categoryAncestors = category.ancestors || [];

    categoryAncestors.map((ancestor, index) => {
      if (!ancestor) {
        return;
      }
      jsonTrail.itemListElement.push({
        "@type": "ListItem",
        position: index + 2,
        name: ancestor.nameTitleCased,
        item: onlineClassesUrl(ancestor.slug, ancestor.basePath)
      });
    });

    jsonTrail.itemListElement.push({
      "@type": "ListItem",
      position: categoryAncestors.length + 2,
      name: category.nameTitleCased,
      item: onlineClassesUrl(
        category.slug,
        (category as CategoryPage)?.basePath
      )
    });

    return [
      {
        type: "application/ld+json",
        innerHTML: JSON.stringify(jsonTrail, undefined, 2)
      }
    ];
  }, [category, t]);
};
